export default __webpack_public_path__ + "static/media/email.f5bf649b.svg";